import React from 'react'

export default function Two() {
    return (
        <section className="two d-flex">
            <div className="container-fluid d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex justify-content-center mb-auto">
                    <img className="img-fluid" alt="" src="/assets/union3.svg" />
                </div>
                <div id="animate" className="zoom-out" data-aos="zoom-in" data-aos-once="true">
                    <img className="img-fluid" alt="" src="/assets/bilhete_mockup_sem-sombra.png" />
                </div>
                <div className="d-flex justify-content-center mt-auto">
                    <img className="star img-fluid" alt="" src="/assets/vector2.png" />
                </div>
            </div>
        </section>
    )
}
